/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconClose = StyledIconInline.extend`
  height: ${props => props.height || '25px'};
  width: ${props => props.width || '24px'};
`;

export const IconClose = (props) => (
    <StyledIconClose {...props}>
        <svg viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M0.4801,1.49035604 L23.4801,24.48975"/>
                <path d="M0.4801,24.489144 L23.4801,1.48975"/>
            </g>
        </svg>
    </StyledIconClose>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconClose/index.js